import { render, staticRenderFns } from "./cardTemplateVip07.vue?vue&type=template&id=79f32c28&scoped=true&"
import script from "./cardTemplateVip07.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip07.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip07.vue?vue&type=style&index=0&id=79f32c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f32c28",
  null
  
)

export default component.exports